import angularScrollMod from '../../common/wrappers/angular-scroll';

class ScrollService {
  constructor($document, $log) {
    'ngInject';

    this.$document = $document;
    this.$log = $log;
  }

  _navigateToId(rootElement, id, offset, delay) {
    const raw_element = document.getElementById(id);
    if (raw_element == null) {
      // Do nothing if the given id does not exist
      this.$log.debug("Tried to scroll to nonexistent ID " + id);
      return;
    }

    const element = angular.element(raw_element);
    // Ensure that element into which to scroll is loaded before scrolling
    element.ready(() => {
      return rootElement.scrollToElement(element, offset, delay)
        .then(() => this.$log.debug(`Scrolled to element ${id}`))
        .catch((err) => this.$log.debug(`Failed to scroll to element ${id} due to ${err}`));
    });
  }

  /**
   * Navigate to a HTML id element if element is found.
   * @param id HTML element id to scroll to.
   * @param offset (optional) Defaults to 0. Offset for scroll. Positive value scrolls higher.
   * @param delay (optional) Defaults to 500. Delay for scrolling.
   * @param rootElementId (optional) Root element for scrolling. Defaults to document root.
   */
  navigateToId(id, offset=0, delay=500, rootElementId=null) {
    let rootElement = null;
    if (rootElementId) {
      rootElement = document.getElementById(rootElementId);
      // Document element might be null. Check it rather than crash on it.
      if (rootElement == null) {
        this.$log.debug("Tried to scroll in a nonexisting rootElement");
        return;
      }
      rootElement = angular.element(rootElement);
    } else {
      rootElement = this.$document;
    }

    // Ensure that rootElement is loaded before advancing
    rootElement.ready(() => this._navigateToId(rootElement, id, offset, delay))
  }
}

const mod = angular.module('app.scroll.service', [angularScrollMod])

.service('ScrollService', ScrollService);

export default mod.name;
